export default "__VITE_ASSET__C6Zjxy5q__"